export function buildTicketWhatsappText(payload: {
  ticketCode: string;
  sorteoNombre: string;
  total: number;
  fecha?: string;
  jugadas: Array<{ num1: string; num2?: string | null; monto: number }>;
}): string {
  const jugadasTexto = payload.jugadas
    .slice(0, 8)
    .map((j) => {
      const numero = j.num2 ? `${j.num1}-${j.num2}` : j.num1;
      return `${numero} ₡${Math.trunc(j.monto)}`;
    })
    .join("\n");

  return [
    "🎰 TICKET",
    `Código: ${payload.ticketCode}`,
    `Sorteo: ${payload.sorteoNombre}`,
    payload.fecha ? `Fecha: ${payload.fecha}` : null,
    "───────────",
    jugadasTexto || "Sin jugadas",
    "───────────",
    `💰 Total: ₡${Math.trunc(payload.total).toLocaleString("es-CR")}`
  ]
    .filter(Boolean)
    .join("\n");
}

/** Detecta si es dispositivo móvil */
function isMobile(): boolean {
  return /Android|iPhone|iPad|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/** Abre WhatsApp con el texto indicado - versión mejorada */
export function openWhatsApp(text: string, telefono?: string): void {
  const encodedText = encodeURIComponent(text);

  // Usar api.whatsapp.com que funciona mejor en todos los dispositivos
  const baseUrl = "https://api.whatsapp.com/send";
  const params = telefono
    ? `?phone=${telefono}&text=${encodedText}`
    : `?text=${encodedText}`;

  const waUrl = baseUrl + params;

  if (isMobile()) {
    // En móvil: abrir en la misma ventana para mejor UX
    window.location.href = waUrl;
  } else {
    // En desktop: abrir en nueva pestaña
    window.open(waUrl, "_blank", "noopener,noreferrer");
  }
}

export async function shareTicketViaWhatsApp(text: string): Promise<void> {
  // Intentar Web Share API primero (mejor en móviles modernos)
  if (navigator.share && isMobile()) {
    try {
      await navigator.share({ text, title: "Ticket GRUPO SONI" });
      return;
    } catch (err: unknown) {
      const error = err as { name?: string };
      if (error?.name === "AbortError") {
        return;
      }
      // Si falla Web Share, continuar con fallback
    }
  }

  // Fallback: abrir WhatsApp directamente
  openWhatsApp(text);
}
